module.exports = __webpack_public_path__ + "static/media/logo-xl.9b004b09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo-xl.svg
// module id = 1205
// module chunks = 2